import { api } from '@setplex/tria-api'
import { combine, createEvent, sample } from 'effector'
import { not } from 'patronum'
import { moviesFavoritesEntityModel } from '~/entities/movies/favorites'

export const loadGridFavoritesMovies = createEvent()

sample({
  clock: loadGridFavoritesMovies,
  filter: not(api.vods.getOnlyFavoritesVodsGridFx.pending),
  target: api.vods.getOnlyFavoritesVodsGridFx,
})

export const $isGridFavoritesMoviesLoading = combine(
  {
    onlyFavoritesMoviesLoading: api.vods.getOnlyFavoritesVodsGridFx.pending,
    onlyFavoritesMovies: moviesFavoritesEntityModel.$onlyFavoritesVodsGrid,
  },
  ({ onlyFavoritesMoviesLoading, onlyFavoritesMovies }) =>
    !onlyFavoritesMovies && onlyFavoritesMoviesLoading
)

export const loadMoreGridFavoritesMovies = createEvent()

sample({
  clock: loadMoreGridFavoritesMovies,
  filter: not(api.vods.getOnlyFavoritesVodsGridFx.pending),
  fn: () => null,
  target: moviesFavoritesEntityModel.loadMoreOnlyFavoritesVodsGrid,
})
